import { observer } from 'mobx-react-lite';
import LogicSettingsPanel from './LogicSettingsPanel';
import type { LogicSettingsPanelProps, LogicSettingsPanelValueProps } from './types';

export type { LogicSettingsPanelProps, LogicSettingsPanelValueProps };
export default observer(LogicSettingsPanel); // MANUAL OVERRIDE
